// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".basket-payments-list{padding:0;margin:0;list-style:none;padding:12px 16px}.basket-payments-list__item{font-size:14px;line-height:24px;margin:0}.basket-payments-list__item+.basket-payments-list__item{margin-top:4px}", ""]);
// Exports
module.exports = exports;
